/* TGGCore: Support & information pages (tgg-sup-* sections).
   Progressive enhancement only. Every answer is in the DOM and every link
   works with JavaScript disabled; this file adds filtering and counters.
   - FAQ: type-to-filter across questions and answers, category chips, deep
     link to a single question via #hash, live result count.
   - City directory: type-to-filter the delivery city list.
   - Copy-to-clipboard for the contact block is intentionally absent: plain
     tel: and mailto: links work everywhere. */
(function () {
  'use strict';

  var norm = function (s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
  var debounce = function (fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms || 120);
    };
  };

  /* ------------------------------------------------------------------ FAQ */
  function initFaq(root) {
    var input = root.querySelector('[data-sup-faq-search]');
    var chips = root.querySelectorAll('[data-sup-cat]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.sup-qa'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.sup-faq__group'));
    var count = root.querySelector('[data-sup-count]');
    var empty = root.querySelector('[data-sup-empty]');
    if (!items.length) return;

    var activeCat = 'all';

    function apply() {
      var q = norm(input && input.value);
      var shown = 0;

      items.forEach(function (item) {
        var haystack = item.getAttribute('data-search') || norm(item.textContent);
        var catOk = activeCat === 'all' || item.getAttribute('data-cat') === activeCat;
        var qOk = !q || haystack.indexOf(q) !== -1;
        var visible = catOk && qOk;
        item.hidden = !visible;
        if (visible) {
          shown++;
          if (q && q.length > 2) item.open = true;
        } else {
          item.open = false;
        }
      });

      groups.forEach(function (group) {
        var any = group.querySelector('.sup-qa:not([hidden])');
        group.hidden = !any;
      });

      if (count) {
        count.textContent = shown === items.length
          ? String(items.length) + ' questions'
          : String(shown) + ' of ' + items.length + ' questions';
      }
      if (empty) empty.hidden = shown !== 0;
    }

    if (input) {
      input.addEventListener('input', debounce(apply, 120));
      input.addEventListener('search', apply);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeCat = chip.getAttribute('data-sup-cat');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        apply();
      });
    });

    /* Deep link: /pages/...#q-how-fast opens and scrolls to that answer. */
    function openFromHash() {
      var id = (window.location.hash || '').replace('#', '');
      if (!id) return;
      var target = root.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/[^a-zA-Z0-9_-]/g, '')));
      if (target && target.classList.contains('sup-qa')) {
        target.hidden = false;
        target.open = true;
        var group = target.closest('.sup-faq__group');
        if (group) group.hidden = false;
        target.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }
    window.addEventListener('hashchange', openFromHash);
    openFromHash();

    apply();
  }

  /* ------------------------------------------------------- city directory */
  function initDirectory(root) {
    var input = root.querySelector('[data-sup-dir-search]');
    var links = Array.prototype.slice.call(root.querySelectorAll('.sup-dir__chips a'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.sup-dir__group'));
    var count = root.querySelector('[data-sup-dir-count]');
    var empty = root.querySelector('[data-sup-dir-empty]');
    if (!input || !links.length) return;

    var total = links.length;

    function apply() {
      var q = norm(input.value);
      var shown = 0;
      links.forEach(function (a) {
        var name = a.getAttribute('data-city') || norm(a.textContent);
        var visible = !q || name.indexOf(q) !== -1;
        a.hidden = !visible;
        if (visible) shown++;
      });
      groups.forEach(function (group) {
        group.hidden = !group.querySelector('.sup-dir__chips a:not([hidden])');
      });
      if (count) {
        count.textContent = shown === total
          ? String(total) + ' places'
          : String(shown) + ' of ' + total + ' places';
      }
      if (empty) empty.hidden = shown !== 0;
    }

    input.addEventListener('input', debounce(apply, 100));
    input.addEventListener('search', apply);
    apply();
  }

  function init() {
    document.querySelectorAll('[data-sup-faq]').forEach(initFaq);
    document.querySelectorAll('[data-sup-dir]').forEach(initDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-init when a section is re-rendered. */
  document.addEventListener('shopify:section:load', init);
})();

/* TGGCore: resolve #shopify-section-<key> anchors.
   The theme editor writes links as #shopify-section-<key>, but Shopify renders
   template sections as id="shopify-section-template--<template id>__<key>", so
   those links match nothing and the click does nothing. The template id differs
   per theme, so it cannot be hardcoded. Match on the key suffix instead.
   Covers the "Read every review" button and jump chip on the reviews page. */
(function () {
  'use strict';

  function resolve(hash) {
    if (!hash || hash.indexOf('#shopify-section-') !== 0) return null;
    var key = hash.slice('#shopify-section-'.length);
    if (!key) return null;
    return document.getElementById('shopify-section-' + key) ||
           document.querySelector('[id^="shopify-section-"][id$="__' + key + '"]');
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#shopify-section-"]');
    if (!a) return;
    var el = resolve('#' + (a.href.split('#')[1] || ''));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', a.getAttribute('href'));
  });

  // A pasted or reloaded URL carrying that hash needs the same treatment.
  document.addEventListener('DOMContentLoaded', function () {
    var el = resolve(window.location.hash);
    if (el) setTimeout(function () { el.scrollIntoView({ block: 'start' }); }, 200);
  });
})();
